// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"ShareButton_buttonWrap__aCLU4","noMr":"ShareButton_noMr__iDC_b","button":"ShareButton_button__GBnjX"};